import axios from 'axios'
import { toast } from 'react-toastify'

let axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
})

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    if (token) {
      ;(config.headers ??= {})['Authorization'] = `Bearer ${token}`
    }

    config.headers['ngrok-skip-browser-warning'] = '123'
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    let errorMessage = ''
    const status = error?.response?.status
    if (status === 500) {
      errorMessage = 'Server error. Please try again later.'
    } else if (status === 400) {
      errorMessage = 'Bad Request. Please check the provided data and try again.'
    } else if (status === 403) {
      errorMessage = 'Forbidden. You do not have permission to access this resource.'
    } else {
      errorMessage = 'We are unable to process your request at this time.'
    }
    toast.error(errorMessage, {
      style: {
        maxWidth: '100%',
        width: 'auto',
      },
    })

    error.data = {}
    return error
  },
)

export default axiosInstance
